import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

// One renderer for every declared field — the class's own and the industry question set's.
export default function FieldInput({ field, form, setForm, recordEdit, prefix = 'class-field-' }) {
  const set = (nv) => { recordEdit?.(field.name, form[field.name], nv); setForm(p => ({ ...p, [field.name]: nv })); };
  const tid = `${prefix}${field.name}`;
  return (
    <div>
      <Label className="text-xs" style={{ color: '#5C6B7A' }}>{field.label}{field.required && <span style={{ color: '#E24B4A' }}> *</span>}</Label>
      {field.type === 'boolean' ? (
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs" style={{ color: '#5C6B7A' }}>{field.label}</span>
          <Switch checked={!!form[field.name]} data-testid={tid} onCheckedChange={set} />
        </div>
      ) : field.type === 'select' ? (
        <select value={form[field.name] || ''} data-testid={tid} onChange={e => set(e.target.value)} required={field.required}
          className="mt-1 w-full px-3 py-2 border border-input rounded-sm text-sm bg-white capitalize">
          <option value="">Select...</option>
          {(field.options || []).map(o => <option key={o} value={o}>{o.replace(/_/g, ' ')}</option>)}
        </select>
      ) : (
        <Input type={field.type === 'number' ? 'number' : 'text'} value={form[field.name] ?? ''} data-testid={tid}
          onChange={e => set(field.type === 'number' ? parseFloat(e.target.value) || 0 : e.target.value)}
          className="mt-1 rounded-sm" required={field.required} placeholder={field.label} />
      )}
    </div>
  );
}
